import styled from 'styled-components';

const W50 = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`;

export default W50;
